import icons from './icons'
import sharedSettings from 'shared/src/settings'

const resources = Object.keys(sharedSettings.resources).reduce((all, name) => {
  const resource = Object.assign({}, sharedSettings.resources[name], {
    icon: icons[name],
  })
  all[name] = resource
  return all
}, {})

const resourceOrder = sharedSettings.resourceOrder

const getSections = ({
  includeFilter,
  excludeFilter,
}) => {
  return resourceOrder
    .filter(sectionName => {
      if(includeFilter) return includeFilter.indexOf(sectionName) >= 0 ? true : false
      else if(excludeFilter) return excludeFilter.indexOf(sectionName) >= 0 ? false : true
      else return true
    })
    .map(sectionName => {
      return Object.assign({}, resources[sectionName], {
        id: sectionName,
      })
    })
}
    

const resourceSettings = {
  resources,
  resourceOrder,
  getSections,
}

export default resourceSettings